import { Link } from '@tanstack/react-router';
import { MarketingPage } from './Chrome';
import styles from './Marketing.module.css';

const PLANS = [
  {
    name: 'Early access',
    price: 'Invite only',
    note: 'Currently onboarding a small group.',
    featured: true,
    features: [
      'Full CRM and chat',
      'Echo timeline and revert',
      'iOS app included',
      'Direct line to the team',
    ],
  },
  {
    name: 'Bring your own key',
    price: 'Planned',
    note: 'Use your own Anthropic key; pay us for the product, not the tokens.',
    featured: false,
    features: ['Everything in Early access', 'Your API key, your usage', 'Usage reporting'],
  },
];

export function PricingPage() {
  return (
    <MarketingPage>
      <h1 className={styles.sectionTitle}>Pricing</h1>
      <div className={styles.plans}>
        {PLANS.map((plan) => (
          <article
            key={plan.name}
            className={plan.featured ? `${styles.plan} ${styles.planFeatured}` : styles.plan}
          >
            <h2 className={styles.planName}>{plan.name}</h2>
            <div className={styles.planPrice}>{plan.price}</div>
            <p className={styles.planNote}>{plan.note}</p>
            <ul className={styles.planList}>
              {plan.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
            {plan.featured ? (
              <Link to="/sign-in" className={styles.cta}>
                Request access
              </Link>
            ) : null}
          </article>
        ))}
      </div>
    </MarketingPage>
  );
}
